import React, {useContext} from "react";
import './FilterIcon.scoped.scss';
import {ProjectsContext} from "../../../views/dashboard/lender/investment/projects/ProjectsContext";
import {resultIf} from "../../../utils";
import CommonFilterIcon from "../CommonFilterIcon";
import FilterSvg from "../../svg/FilterSvg";

type Props = {
  active?: boolean;
  onClick?: () => void;
};

const FilterIcon = ({active, onClick}: Props) => {
  const context = useContext(ProjectsContext);
  const isActive = active ?? context.filterActive;
  const toggle = onClick ?? context.toggleFilter;
  return (
    <CommonFilterIcon onClick={toggle} className={resultIf(isActive, "active")}>
      <FilterSvg />
    </CommonFilterIcon>
  );
};

export default FilterIcon;